import React from "react";
import { Box, Paper, Skeleton, Stack } from "@mui/material";

/**
 * Skeleton for Account & Settings (profile + wallet only).
 */
export default function AdminSettingsSkeleton() {
  return (
    <Box sx={{ flex: 1, minWidth: 0, px: 2 }}>
      <Skeleton variant="text" width={140} height={28} sx={{ mb: 2 }} />

      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 3 }}>
        <Skeleton variant="rounded" width={50} height={50} sx={{ borderRadius: 1 }} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width={220} height={32} />
          <Skeleton variant="text" width={260} height={20} sx={{ mt: 0.5 }} />
        </Box>
      </Stack>

      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          p: 3,
          mb: 3,
          bgcolor: "background.paper",
        }}
      >
        <Skeleton variant="text" width={180} height={26} />
        <Skeleton variant="text" width={280} height={20} sx={{ mb: 3 }} />

        <Stack direction={{ xs: "column", md: "row" }} spacing={3}>
          <Box sx={{ flex: 1 }}>
            <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
              <Skeleton variant="circular" width={64} height={64} />
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width="70%" height={24} />
                <Skeleton variant="text" width="50%" height={18} sx={{ mt: 1 }} />
              </Box>
            </Stack>
            <Stack direction="row" spacing={2}>
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width={100} height={14} />
                <Skeleton variant="text" width="90%" height={22} sx={{ mt: 0.5 }} />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width={100} height={14} />
                <Skeleton variant="text" width="90%" height={22} sx={{ mt: 0.5 }} />
              </Box>
            </Stack>
          </Box>
          <Box sx={{ flex: 1, maxWidth: { md: 360 } }}>
            <Skeleton variant="rounded" height={140} sx={{ borderRadius: 2 }} />
          </Box>
        </Stack>

        <Skeleton variant="rounded" height={56} sx={{ mt: 3, borderRadius: 2 }} />
      </Paper>

      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          p: 3,
          mb: 3,
          bgcolor: "background.paper",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          sx={{ mb: 2 }}
        >
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={100} height={26} />
            <Skeleton variant="text" width={280} height={20} />
          </Box>
          <Skeleton variant="rounded" width={140} height={32} sx={{ borderRadius: 2 }} />
        </Stack>
        <Skeleton variant="rounded" height={220} sx={{ borderRadius: 3 }} />
      </Paper>
    </Box>
  );
}
